module.exports = __webpack_public_path__ + "img/icon-revision.b521d9ed.svg";